import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/ChatOnboarding/resolveRequestPortfolioLabels";
const I18n = I18nUtil.createScoped(Translations);
export interface RequestPortfolioArgsLike {
  title?: string;
  connectLabel?: string;
  otherWaysLabel?: string;
  uploadStatementLabel?: string;
  snapPhotoLabel?: string;
  /** @deprecated use snapPhotoLabel */
  uploadLabel?: string;
  skipLabel?: string;
}

export interface RequestPortfolioCardLabels {
  title: string;
  connectLabel: string;
  otherWaysLabel: string;
  uploadStatementLabel: string;
  snapPhotoLabel: string;
  skipLabel: string;
}

const DEFAULT_REQUEST_PORTFOLIO_TITLE = I18n.t(
  "Let me know more about your assets",
);

/** request_portfolio 交互态 / 查看态共用的默认文案 */
export const getDefaultRequestPortfolioLabels =
  (): RequestPortfolioCardLabels => ({
    title: DEFAULT_REQUEST_PORTFOLIO_TITLE,
    connectLabel: I18n.t("Connect portfolio"),
    otherWaysLabel: I18n.t("Other ways"),
    uploadStatementLabel: I18n.t("Upload a statement"),
    snapPhotoLabel: I18n.t("Snap a photo"),
    skipLabel: I18n.t("Maybe later"),
  });

export const resolveRequestPortfolioLabels = (
  args?: RequestPortfolioArgsLike,
): RequestPortfolioCardLabels => {
  const defaults = getDefaultRequestPortfolioLabels();

  return {
    title: args?.title?.trim() || defaults.title,
    connectLabel: defaults.connectLabel,
    otherWaysLabel: defaults.otherWaysLabel,
    uploadStatementLabel: defaults.uploadStatementLabel,
    snapPhotoLabel: defaults.snapPhotoLabel,
    skipLabel: defaults.skipLabel,
  };
};

export const isRequestPortfolioArgs = (
  value: unknown,
): value is RequestPortfolioArgsLike & {
  title: string;
  connectLabel: string;
} => {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as RequestPortfolioArgsLike;

  return (
    typeof candidate.title === "string" &&
    typeof candidate.connectLabel === "string"
  );
};
